export const ACTIVE_RARITY_KEYS = Object.freeze([
  "common",
  "uncommon",
  "rare",
  "epic",
  "legendary",
]);

export const RESERVED_RARITY_KEYS = Object.freeze(["unique"]);

// Canonical active product order. Reserved/legacy rarities are intentionally excluded.
export const RARITY_DISPLAY_ORDER = Object.freeze([...ACTIVE_RARITY_KEYS]);

// Use only on surfaces that explicitly need to render already-existing legacy data.
export const RARITY_LEGACY_DISPLAY_ORDER = Object.freeze([
  ...ACTIVE_RARITY_KEYS,
  ...RESERVED_RARITY_KEYS,
]);

export const RARITY_COLOR_VARS = Object.freeze({
  common: "var(--rarity-common-border)",
  uncommon: "var(--rarity-uncommon-border)",
  rare: "var(--rarity-rare-border)",
  epic: "var(--rarity-epic-border)",
  legendary: "var(--rarity-legendary-border)",
  unique: "var(--rarity-unique-border)",
});

const RARITY_SORT_RANK = new Map(
  RARITY_LEGACY_DISPLAY_ORDER.map((rarity, index) => [rarity, index])
);

export function normalizeRarityKey(value) {
  const normalized = String(value ?? "").trim().toLowerCase();
  return Object.hasOwn(RARITY_COLOR_VARS, normalized) ? normalized : "";
}

export function getRarityToneClass(value) {
  const rarity = normalizeRarityKey(value);
  return rarity ? `rarity-${rarity}` : "";
}

export function getRarityColorVar(value, fallback = "var(--text-muted)") {
  const rarity = normalizeRarityKey(value);
  return rarity ? RARITY_COLOR_VARS[rarity] : fallback;
}

export function getRaritySortIndex(value, { includeReserved = true } = {}) {
  const rarity = normalizeRarityKey(value);
  if (!rarity) return Number.MAX_SAFE_INTEGER;
  if (!includeReserved && RESERVED_RARITY_KEYS.includes(rarity)) {
    return Number.MAX_SAFE_INTEGER;
  }
  return RARITY_SORT_RANK.get(rarity) ?? Number.MAX_SAFE_INTEGER;
}

export function getRarityDisplayOrder(explicitKeys = []) {
  const explicit = new Set(
    (Array.isArray(explicitKeys) ? explicitKeys : [])
      .map(normalizeRarityKey)
      .filter(Boolean)
  );
  return [
    ...RARITY_DISPLAY_ORDER,
    ...RESERVED_RARITY_KEYS.filter((rarity) => explicit.has(rarity)),
  ];
}
